import { Tooltip as ChakraTooltip, Portal } from "@chakra-ui/react"
import * as React from "react"

/**
 * 
 * TooltipProps {
 * showArrow?: boolean
 * portalled?: boolean
 * portalRef?: React.RefObject<HTMLElement>
 * content: React.ReactNode
 * contentProps?: ChakraTooltip.ContentProps
 * disabled?: boolean
 */
export const CustomTooltip = React.forwardRef(
  function Tooltip(props, ref) {
    const {
      showArrow,
      children,
      disabled,
      portalled = true,
      content,
      contentProps,
      portalRef,
      ...rest
    } = props

    if (disabled) return children

    return (
      <ChakraTooltip.Root {...rest}>
        <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>
        <Portal disabled={!portalled} container={portalRef}>
          <ChakraTooltip.Positioner position="bottom-start">
            <ChakraTooltip.Content ref={ref} {...contentProps}>
              {showArrow && (
                <ChakraTooltip.Arrow>
                  <ChakraTooltip.ArrowTip />
                </ChakraTooltip.Arrow>
              )}
              {content}
            </ChakraTooltip.Content>
          </ChakraTooltip.Positioner>
        </Portal>
      </ChakraTooltip.Root>
    )
  },
)
